import React, { useState } from "react";
import {
  FeeHomeCard,
  FormControlSearch,
  LoaderWrapper,
  ManageFeeLayout,
  WarningModal,
} from "../../../components";
import {
  faBan,
  faCheck,
  faPauseCircle,
} from "@fortawesome/pro-light-svg-icons";
import { Button, Image, InputGroup } from "react-bootstrap";
import * as fileSaver from "file-saver";
import { useHistory } from "react-router";
import ExcelImage from "../../../styles/exportimg.PNG";
import {
  EMPLOYEE_RECORDS_TO_FETCH,
  MANAGE_FEE_ROUTES,
  formFields,
  getPathWithParam,
  manageFeeFormNames,
  usDateFormat,
} from "../../../utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Formik } from "formik";
import {
  cancelTradeByFeeId,
  downloadFeeTransactionListingReport,
  getFeeRunListingDetailsBySearchCriteria,
} from "../../../services";
import InfiniteScroll from "react-infinite-scroller";
import { useDeepEffect } from "../../../abstracts";

const ManageRunFeeContainer = (props) => {
  const formName = manageFeeFormNames.FEE_RUN_SEARCH;
  const fields = formFields[formName];
  const [selectedFeeRun, setSelectedFeeRun] = useState({});
  const [feeRunData, setFeeRunData] = useState([]);
  const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);
  const [append, setAppend] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [request, setRequest] = useState({
    searchString: "",
    from: 0,
    numberOfRecordsToBeFetched: EMPLOYEE_RECORDS_TO_FETCH,
  });
  const history = useHistory();
  const searchTextBox = (e) => {
    if (e.key === "Enter") {
      setIsLoading(true);
      getFeeRunListingDetailsBySearchCriteria({
        searchString: e.target.value,
        from: 0,
        numberOfRecordsToBeFetched: EMPLOYEE_RECORDS_TO_FETCH,
      }).then((res) => {
        if (res.isSuccessfull) {
          setIsLoading(false);
          setFeeRunData(res.feeTransaction);
        }
      });
    }
  };
  const dataWidth = [
    { width: "25%", align: "left" },
    { width: "15%", align: "center" },
    { width: "15%", align: "center" },
    { width: "15%", align: "center" },
    { width: "15%", align: "center" },
    { width: "20%", align: "center" },
  ];
  const header = [
    { name: "Fee Name & Description", width: "25%", align: "left" },
    { name: "Fee Classification", width: "15%", align: "center" },
    { name: "No.Of Plan(s)", width: "15%", align: "center" },
    { name: "Fee Amount", width: "15%", align: "center" },
    { name: "Fee Run Date", width: "15%", align: "center" },
    { name: "Fee Run Status", width: "20%", align: "center" },
  ];
  let initialValues = {
    [fields.searchString]: "",
    [fields.from]: 0,
    [fields.numberOfRecordsToBeFetched]: 20,
  };
  const cancelTrade = (id) => {
    setIsLoading(true);
    cancelTradeByFeeId(id)
      .then((respon) => {
        if (respon) {
          getFeeRunListingDetailsBySearchCriteria(request).then((res) => {
            if (res.isSuccessfull) {
              setFeeRunData(res.feeTransaction);
              setModalVisible(false);
              setIsLoading(false);
            }
          });
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };
  const exportFeeRun = () => {
    downloadFeeTransactionListingReport()
      .then((response) => {
        var blob = new Blob([response], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fileSaver.saveAs(
          blob,
          //"PayrollSummary.xlsx"
          `Fee Run Report_ ${usDateFormat(new Date())}.xlsx`
        );
      })
      .catch((error) => {});
  };
  useDeepEffect(() => {
    setIsLoading(true);
    getFeeRunListingDetailsBySearchCriteria(request)
      .then((res) => {
        if (res.isSuccessfull) {
          if (res?.feeTransaction?.length < EMPLOYEE_RECORDS_TO_FETCH)
            setStopInfiniteScroll(true);
          if (append) {
            setFeeRunData((feerunList) => {
              return [...feerunList, ...res.feeTransaction];
            });
          } else {
            setFeeRunData(res.feeTransaction);
          }
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }, [request]);
  const getStatus = (status) => {
    switch (status) {
      case "AwaitingTrade":
        return (
          <span className="isDraft">
            <FontAwesomeIcon icon={faPauseCircle} /> Awaiting Trade
          </span>
        );
      case "AwaitingTradeConfirmation":
        return (
          <span className="isDraft">
            <FontAwesomeIcon icon={faPauseCircle} /> Awaiting Trade Confirmation
          </span>
        );
      case "TradeRejected":
        return (
          <span className="rejected">
            <FontAwesomeIcon icon={faBan} /> Trade Rejected
          </span>
        );
      case "Cancelled":
        return (
          <span className="rejected">
            <FontAwesomeIcon icon={faBan} /> Cancelled
          </span>
        );
      case "Failed":
        return (
          <span className="rejected">
            <FontAwesomeIcon icon={faBan} /> Failed
          </span>
        );
      case "Completed":
        return (
          <span className="isActive">
            <FontAwesomeIcon icon={faCheck} /> Completed
          </span>
        );
      default:
        return (
          <span className="isDraft">
            <FontAwesomeIcon icon={faPauseCircle} /> Awaiting Trade Confirmation
          </span>
        );
    }
  };
  const FeeDetailNavigate = (id, step) => {
    history.push(
      getPathWithParam({
        path: MANAGE_FEE_ROUTES.FEE_RUN_DETAILS,
        pathParam: [id],
      })
    );
  };

  return (
    <ManageFeeLayout>
      <LoaderWrapper isLoading={isLoading} className="disableoverflow">
        <Formik
          enableReinitialize
          validateOnChange={false}
          validateOnBlur={false}
          initialValues={{
            ...initialValues,
          }}
        >
          {(formProps) => {
            const {
              handleChange,
              setFieldValue,
              handleSubmit,
              setValues,
              setTouched,
              values,
              setSubmitting,
              setFieldError,
              fieldValue,
              ...rest
            } = formProps;
            const onDaySelected = (fieldName, value) => {
              setFieldValue(fieldName, value);
            };
            return (
              <div className="d-flex justify-content-between">
                <div className="d-flex" style={{ width: "70%" }}>
                  <div className="search-wrapper w-20 ml-2 mb-3">
                    <div className="grey-text ft-14 pt-2">Search Fee Run</div>
                    <InputGroup>
                      <InputGroup.Prepend>
                        <div className="search-icon-postion">
                          <i class="fas fa-search" aria-hidden="true"></i>
                        </div>
                      </InputGroup.Prepend>
                      <FormControlSearch
                        size="md"
                        type="search"
                        className="plan-search-box pad-left-search"
                        placeholder="Search"
                        onChange={(e) => null}
                        onKeyPress={(e) => {
                          searchTextBox(e);
                        }}
                      />
                    </InputGroup>
                  </div>
                  {/* <div className="d-flex ml-3 mr-3 ">
                    <Field
                      size="sm"
                      label="From Date"
                      isRequired
                      name={fields.startDate}
                      value={usDateFormat(values[fields.startDate])}
                      direction="bottom"
                      isDatePicker
                      onClear={() => setFieldValue(fields.startDate, "")}
                      validate={(value) =>
                        ["", undefined, null, "Select One"].includes(value) &&
                        isEmpty(values[fields.startDate])
                          ? "Required"
                          : null
                      }
                      popupContent={
                        <DatePicker
                          onDayClick={(value) =>
                            onDaySelected(fields.startDate, value)
                          }
                          value={usDateFormat(values[fields.startDate])}
                        />
                      }
                      component={FieldDropSide}
                    />
                  </div>
                  <div className="d-flex ml-3 mr-3 ">
                    <Field
                      size="sm"
                      label="To Date"
                      isRequired
                      name={fields.endDate}
                      value={usDateFormat(values[fields.endDate])}
                      direction="bottom"
                      isDatePicker
                      onClear={() => setFieldValue(fields.endDate, "")}
                      validate={(value) =>
                        ["", undefined, null, "Select One"].includes(value) &&
                        isEmpty(values[fields.endDate])
                          ? "Required"
                          : null
                      }
                      popupContent={
                        <DatePicker
                          onDayClick={(value) =>
                            onDaySelected(fields.endDate, value)
                          }
                          value={usDateFormat(values[fields.endDate])}
                        />
                      }
                      component={FieldDropSide}
                    />
                  </div> */}
                </div>
                <span
                  className="mr-2 mt-12 sort-button cursor-pointer payroll-btns"
                  style={{ lineHeight: "19px" }}
                  onClick={() => exportFeeRun()}
                >
                  <Image src={ExcelImage} width="20px" />
                  <u>Export</u>
                </span>
              </div>
            );
          }}
        </Formik>
        <div className="pt-2">
          <div className="ml-2 mt-4 grey-text">
            {feeRunData?.length} Records found
          </div>
          <div className="p-3 d-flex align-center">
            {header.map((name) => {
              return (
                <div
                  className="ft-14 grey-text"
                  style={{ width: name.width, textAlign: name.align }}
                >
                  {name.name}
                  {/* <FontAwesomeIcon size="md" className="ml-2" icon={faSort} /> */}
                </div>
              );
            })}
          </div>
          <InfiniteScroll
            pageStart={0}
            loadMore={() => {
              setAppend(true);
              setRequest((request) => {
                return { ...request, from: feeRunData?.length };
              });
            }}
            hasMore={!stopInfiniteScroll}
            initialLoad={false}
            threshold={100}
            useWindow={false}
            loader={
              <div className="loader" key={0}>
                Loading ...
              </div>
            }
          >
            {feeRunData?.length == 0 ? (
              <div
                style={{
                  width: "30%",
                  top: "50%",
                  left: "40%",
                  position: "absolute",
                  fontSize: "20px",
                }}
              >
                No Records Found
              </div>
            ) : (
              <div className="fee-scroll">
                {feeRunData?.map((content) => {
                  return (
                    <div
                      className="fee-layout"
                      onClick={() =>
                        FeeDetailNavigate(content?.id, content?.feeRunStatus)
                      }
                    >
                      <FeeHomeCard
                        description={content.description}
                        header={header}
                        dataWidth={dataWidth}
                        data={content}
                        isFeeTransaction={true}
                        getStatus={getStatus}
                      />
                    </div>
                  );
                })}
              </div>
            )}
          </InfiniteScroll>
        </div>

        <WarningModal show={modalVisible} onHide={() => setModalVisible(false)}>
          <div className="remove-text">
            <h4>Cancel Trade?</h4>
            <p>
              This will cancel processing trade for the transaction. Are you ok
              to proceed?
            </p>
            <Button
              type="button"
              className="remove-btn mr-4"
              onClick={() => cancelTrade(selectedFeeRun?.id)}
            >
              Confirm
            </Button>
            <Button
              className="cancel-btn"
              onClick={() => {
                setModalVisible(false);
              }}
            >
              Cancel
            </Button>
          </div>
        </WarningModal>
      </LoaderWrapper>
    </ManageFeeLayout>
  );
};

export default ManageRunFeeContainer;
